import PersonneCardVisualisation from "./PersonneCardVisualisation";
import FondateurCardVisualisation from "./FondateurCardVisualisation";
import FicheSuivi from "./FicheSuivi";
import FicheSuiviMembres from "./FicheSuiviMembres";
import FicheSuiviDocuments from "./FicheSuiviDocuments";
import FicheSuiviReprise from "./FicheSuiviReprise";
import FicheSuiviExtraitDialog from "./FicheSuiviExtraitDialog";
import AssociationHistorique from "./AssociationHistorique";
import AssociationToolbar from "./AssociationToolbar";
import FicheSuiviAdministrateurs from "./FicheSuiviAdministrateurs";
import InvitationUsagerDialog from "./InvitationUsagerDialog";
import ModificationUsagerDialog from "./ModificationUsagerDialog";
import SupprimeUsagerDialog from "./SupprimeUsagerDialog";
import SupprimeInvitationDialog from "./SupprimeInvitationDialog";
import FicheSuiviNumerisationDialog from "./FicheSuiviNumerisationDialog";
import FicheSuiviRattachementDialog from "./FicheSuiviRattachementDialog";
import ReenvoiInvitationDialog from "./ReenvoiInvitationDialog";
import FicheAssociationAideDialog from "./FicheAssociationAideDialog";
import AssociationEtatChip from "./AssociationEtatChip";

export default {
    install(Vue) {
        Vue.component("a-personne-visualisation-card", PersonneCardVisualisation);
        Vue.component("a-fondateur-visualisation-card", FondateurCardVisualisation);
        Vue.component("a-fiche-suivi", FicheSuivi);
        Vue.component("a-fiche-suivi-membres", FicheSuiviMembres);
        Vue.component("a-fiche-suivi-documents", FicheSuiviDocuments);
        Vue.component("a-fiche-suivi-administrateurs", FicheSuiviAdministrateurs);
        Vue.component("a-fiche-suivi-reprise", FicheSuiviReprise);
        Vue.component("a-fiche-suivi-extrait-dialog", FicheSuiviExtraitDialog);
        Vue.component("a-association-historique", AssociationHistorique);
        Vue.component("a-association-toolbar", AssociationToolbar);
        Vue.component("a-invitation-usager-dialog", InvitationUsagerDialog);
        Vue.component("a-modification-usager-dialog", ModificationUsagerDialog);
        Vue.component("a-supprime-usager-dialog", SupprimeUsagerDialog);
        Vue.component("a-supprime-invitation-dialog", SupprimeInvitationDialog);
        Vue.component("a-fiche-suivi-numerisation-dialog", FicheSuiviNumerisationDialog);
        Vue.component("a-fiche-suivi-rattachement-dialog", FicheSuiviRattachementDialog);
        Vue.component("a-reenvoi-invitation-dialog", ReenvoiInvitationDialog);
        Vue.component("a-fiche-association-aide-dialog", FicheAssociationAideDialog);
        Vue.component("a-association-etat-chip", AssociationEtatChip);
    }
}
